<template>
	<div>
		<div class="haed-logo">
			<div class="container flex align-center">
				<div class="logo">
					<router-link to="/"><img src="@/assets/logo_xa.png" alt=""></router-link>
				</div>
				<div class="logo_line"></div>
				<div>
					<img class="logo_1" src="@/assets/gj.png" alt="">
					<img class="logo_2" src="@/assets/sjs.png" alt="">
					<img class="logo_2" src="@/assets/bjs.png" alt="">
				</div>
			</div>
		</div>
		<div class="base-nav">
			<div class="container" style="position: relative;">
				<!-- <div class="logo">
					<img src="@/assets/logo.png" alt="">
				</div> -->
				<ul class="nav-link">
					<li v-for="(item,index) in navList" :key="index" class="nav-item" :class="$route.path==item.pid.linkUrl||$route.matched[0].path==item.pid.linkUrl?'active':''"  v-if="item.childList==''">
						<router-link :to="{path:item.pid.linkUrl}" tag="a">{{item.pid.menu}}</router-link>
					</li>
					<li class="nav-item" v-else :class="$route.path==item.pid.linkUrl||$route.matched[0].path==item.pid.linkUrl?'active':''">
						<a-popover>
							<template slot="content">
								<div class="sub-nav" v-for="(child,cindex) in item.childList">
									<router-link :to="{path:child.linkUrl,query:{menuPosition:child.id}}">{{child.menu}}</router-link>
								</div>
							</template>
							<router-link  :to="{path:item.pid.linkUrl}">{{item.pid.menu}}
								<a-icon type="down" :style="{fontSize:'14px'}" />
							</router-link>
						</a-popover>
					</li>

				</ul>
<!--				<div class="search-box" @mouseleave="showSearch=false" v-if="showSearch">-->
<!--					<div class="flex align-center">-->
<!--						&lt;!&ndash; <img width="20" src="@/assets/search.png" alt=""> &ndash;&gt;-->
<!--						<input type="text" class="input-search" v-model="keywords" placeholder="请输入你要搜索的内容">-->
<!--					</div>-->
<!--					<div class="flex align-center">-->
<!--						<a-divider style="margin-right: 30px;margin-top:5px;" type="vertical" />-->
<!--						<a @click="doSearch" class="search-btn">搜索</a>-->
<!--					</div>-->
<!--				</div>-->
<!--				<div class="" v-if="!showSearch" @mouseover="showSearch=true">-->
<!--					<a><img src="@/assets/search.png" width="20" alt=""></a>-->
<!--				</div>-->
				<!-- <div class="nav-icon">
					<a v-if="!show" @mouseenter="showQrcode"><img src="../assets/qrcode_base.png" alt=""></a>
					<a v-if="show" @mouseleave="hideQrcode"><img src="../assets/qrcode_show.png" alt=""></a>
					<div class="mp-qrcode" v-if="show">
						<img src="../assets/mp_qrcode.png" alt="">
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				keywords:"",
				navList:[],
				showSearch:false,
			}
		},
		created() {
			this.getNavigation();
		},
		mounted() {

		},
		methods: {
			showQrcode() {
				this.show = true;
			},
			hideQrcode() {
				this.show = false;
			},
			doSearch() {
				this.$router.push({path:"/searchNews",query:{keywords:this.keywords}});
			},
			getNavigation(){
				let _navList = sessionStorage.getItem("navList");
				if(_navList){
					this.navList = JSON.parse(_navList);
				}else{
					this.$request({
						url:this.$api.public.getNavigation
					}).then((res)=>{
						this.navList = res.data.result.list;
						sessionStorage.setItem("navList",JSON.stringify(this.navList));
						// this.$router.push({path:this.navList[0].pid.linkUrl,query:{menuPosition:this.navList[0].pid.id}})
					})
				}

			},
		}
	}
</script>

<style scoped>
	.logo_line{
		height: 46px;
		width: 1px;
		background-color: #ededed;
		margin-left: 24px;
		margin-right: 24px;
	}


	.haed-logo{
		padding-top:15px;
		background-color: #FFF;
	}

	.logo img {
		width: 210px;
		height: 46px;
	}


	.base-nav {
		height: 60px;
		line-height: 60px;
		background-color: white;
	}

	.base-nav .container {
		display: flex;
		justify-content: space-between;
	}


	.nav-link {
		display: flex;
		margin: 0px;
		padding: 0px !important;
	}

	.nav-link .nav-item {
		list-style: none;
		border-top: 2px solid white;
		margin-right: 35px;
	}

	.nav-link .nav-item a {
		font-size: 18px;
		font-weight: 500;
		color: #383838;
	}

	.nav-link .active {
		/* border-top: 2px solid #13B8EE; */
	}

	.nav-link .active a {
		color: #13B8EE;
	}

	.nav-link .nav-item:hover a {
		color: #13B8EE;
	}

	.nav-icon {
		text-align: right;
		position: relative;
	}

	.nav-icon .mp-qrcode {
		position: absolute;
		top: 120px;
		right: 0;
		z-index: 999;
	}

	.sub-nav {
		padding: 8px 15px;
	}

	.sub-nav a {
		color: #1A1A1A;
	}

	.sub-nav a:hover {
		color: #13B8EE;
	}


	.search-box {
		/* width: 1200px; */
		position: absolute;
		/* right:350px; */
		border-radius: 8px;
		right: 0;
		height: 40px;
		margin-top: 10px;
		padding: 20px;
		background-color: #FFFFFF;
		/* box-shadow: 0px 0px 8px rgba(30, 34, 170, 0.08); */
		z-index: 999;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid #ededed;
	}

	.input-search {
		/* margin-left: 30px; */
		font-size: 14px;
		height: 40px;
		border: none;
		/* border: 1px solid #ededed; */
		outline: none !important;
		/* width: 1000px; */
		width: 170px;
	}

	.ant-divider,
	.ant-divider-vertical {
		/* height: 1.1em; */
	}

	.search-btn {
		color: #333333;
		font-weight: 500;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/components/BaseNavigation.vue